import SubPage from "@/layout/SubPage.vue"

export default {
  path: "base",
  name: "base",
  component: SubPage,
  meta: { title: "基础模块", icon: "dashboard" },
  hidden: true,
  children: [
  // --- 系统词典 ---
    {
      path: "dictionary",
      name: "dictionary",
      component: SubPage,
      meta: { title: "系统词典 ", icon: "dashboard" },
      hidden: true,
      props: true,
      children: [// --- 数据字典 ---
      // --- 医药字典 ---
        {
          path: "medicine_dic",
          name: "medicineDic",
          component: SubPage,
          meta: { title: "医药字典", icon: "dashboard" },
          hidden: true,
          props: true,
          children: [{
            path: "med_directory/:viewMode/:mode",
            name: "medDirectory",
            component: () => import("@/views/business/page/manager/base/dictionary/medicinedic/MedDirectory"),
            meta: { title: "药品词典", icon: "dashboard" },
            hidden: true,
            props: true
          }, {
            path: "chain_directory/:viewMode/:mode",
            name: "chainDirectory",
            component: () => import("@/views/business/page/manager/base/dictionary/medicinedic/ChainDirectory"),
            meta: { title: "供应链词典", icon: "dashboard" },
            hidden: true,
            props: true
          }, {
            path: "materiel_type/:viewMode/:mode",
            name: "materielType",
            component: () => import("@/views/business/page/manager/base/dictionary/medicinedic/MaterielType"),
            meta: { title: "物料类型", icon: "dashboard" },
            hidden: true,
            props: true
          }, {
            path: "classify_directory/:viewMode/:mode",
            name: "classifyDirectory",
            component: () => import("@/views/business/page/manager/base/dictionary/medicinedic/ClassifyDirectory"),
            meta: { title: "物料分类词典", icon: "dashboard" },
            hidden: true,
            props: true
          }, {
            path: "materiel/:viewMode/:mode",
            name: "materiel",
            component: () => import("@/views/business/page/manager/base/dictionary/medicinedic/Materiel"),
            meta: { title: "物料词典", icon: "dashboard" },
            hidden: true,
            props: true
          }]
        }
      ]
    }]
}
